var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '../typography/typography';
import { classNames } from '../../utils';
export var Note = function (_a) {
    var className = _a.className, title = _a.title, subTitle = _a.subTitle, body = _a.body;
    return (_jsxs("div", __assign({ className: classNames(className, 'bg-uiBg rounded-15 p-4') }, { children: [_jsx(Typography, { type: "h3", text: title, color: "textDark" }), _jsx(Typography, { type: "help", text: subTitle, color: "textLight" }), _jsx(Typography, { type: "body", text: body, color: "textMid" })] })));
};
//# sourceMappingURL=index.js.map